<template>
  <div id="home">
    <div class="nav-menu" @click="isShow = !isShow">
      <div class="header">
        <img
          @click="back"
          title="Back"
          style="cursor: pointer"
          src="../assets/icon/back.png"
        />
      </div>
      <el-menu
        class="el-menu-vertical-demo"
        background-color="#27333d"
        text-color="#eeeeef"
        v-if="this.projectInfo"
      >
        <el-tooltip effect="light" :open-delay="500">
          <el-menu-item index="1">
            <span class="icon">
              <img src="../assets/icon/01.svg" alt="" />
            </span>
            <span class="title" v-if="isShow">
              <span>
                {{ this.projectInfo.groupCustomer_Name }}
              </span>
            </span>
          </el-menu-item>
          <template slot="content">
            <span style="display:flex; align-items: center;">
              {{ this.projectInfo.groupCustomer_Name }}
            </span>
          </template>
        </el-tooltip>

        <el-tooltip effect="light" :open-delay="500">
          <el-menu-item index="2">
            <span class="icon">
              <img src="../assets/icon/02.svg" alt="" />
            </span>
            <span class="title" v-if="isShow">
              <span>
                {{
                  isEmpty(this.projectInfo.city)
                    ? ""
                    : this.projectInfo.city.length > 20
                    ? this.projectInfo.city.substring(0, 20) + "..."
                    : this.projectInfo.city
                }}
              </span>
            </span>
          </el-menu-item>
          <template slot="content">
            <span style="display:flex; align-items: center;">
              {{ this.projectInfo.city }}
            </span>
          </template>
        </el-tooltip>

        <el-tooltip effect="light" :open-delay="500">
          <el-menu-item index="3">
            <span class="icon">
              <img src="../assets/icon/03.svg" alt="" />
            </span>
            <span class="title" v-if="isShow"
              ><span>
                {{ this.projectInfo.locationType }}
              </span>
            </span>
          </el-menu-item>
          <template slot="content">
            <span style="display:flex; align-items: center;">
              {{ this.projectInfo.locationType }}
            </span>
          </template>
        </el-tooltip>

        <el-tooltip effect="light" :open-delay="500">
          <el-menu-item index="4">
            <span class="icon">
              <img src="../assets/icon/04.svg" alt="" />
            </span>
            <span class="title" v-if="isShow">
              <span>
                {{ this.projectInfo.action }}
              </span>
            </span>
          </el-menu-item>
          <template slot="content">
            <span style="display:flex; align-items: center;">
              {{ this.projectInfo.action }}
            </span>
          </template>
        </el-tooltip>

        <el-tooltip effect="light" :open-delay="500">
          <el-menu-item index="5">
            <span class="icon">
              <img src="../assets/icon/05.svg" alt="" />
            </span>
            <span class="title" v-if="isShow">
              <span>
                {{ this.mpsa }}
              </span>
            </span>
          </el-menu-item>
          <template slot="content">
            <span style="display:flex; align-items: center;">
              {{ this.mpsa }}
            </span>
          </template>
        </el-tooltip>

        <el-tooltip effect="light" :open-delay="500">
          <el-menu-item index="6">
            <span class="icon">
              <img
                style="width: 34px; height: 34px"
                src="../assets/icon/06.svg"
                alt=""
              />
            </span>
            <span class="title" v-if="isShow">
              <span>
                {{ this.projectInfo.sFloor }}
              </span>
            </span>
          </el-menu-item>
          <template slot="content">
            <span style="display:flex; align-items: center;">
              {{ this.projectInfo.sFloor }}
            </span>
          </template>
        </el-tooltip>

        <el-tooltip effect="light" :open-delay="500">
          <el-menu-item index="7">
            <span class="icon">
              <img src="../assets/icon/07.svg" alt="" />
            </span>
            <span class="title" v-if="isShow">
              <span>
                {{ space }}
              </span>
            </span>
          </el-menu-item>
          <template slot="content">
            <span style="display:flex; align-items: center;">
              {{ space }}
            </span>
          </template>
        </el-tooltip>

        <el-tooltip effect="light" :open-delay="500">
          <el-menu-item index="8">
            <span class="icon">
              <img src="../assets/icon/08.svg" alt="" />
            </span>
            <span class="title" v-if="isShow">
              <span
                v-if="!!formats && formats.length > 25"
                style="
                display: flex;
                justify-content: center;
                flex-direction: column;
                line-height: normal;
                height: 56px;
              "
              >
                <span> {{ formats.split("-->")[0] }} → </span>
                <span>
                  {{ formats.split("-->")[1] }}
                </span>
              </span>
              <span v-if="formats.length < 26">
                <span>
                  {{ formats }}
                </span>
              </span>
            </span>
          </el-menu-item>
          <template slot="content">
            <span style="display:flex; align-items: center;">
              {{ formats }}
            </span>
          </template>
        </el-tooltip>

        <el-tooltip effect="light" :open-delay="500">
          <el-menu-item index="9">
            <span class="icon">
              <img src="../assets/icon/09.svg" alt="" />
            </span>
            <span class="title" v-if="isShow">
              <span>
                {{ this.projectInfo.fixtureSupport }}
              </span>
            </span>
          </el-menu-item>
          <template slot="content">
            <span style="display:flex; align-items: center;">
              {{ this.projectInfo.fixtureSupport }}
            </span>
          </template>
        </el-tooltip>

        <el-tooltip effect="light" :open-delay="500">
          <el-menu-item index="10">
            <span class="icon">
              <img src="../assets/icon/10.svg" alt="" />
            </span>
            <span class="title" v-if="isShow">
              <span>
                {{ this.projectInfo.requestOpenDate }}
              </span>
            </span>
          </el-menu-item>
          <template slot="content">
            <span style="display:flex; align-items: center;">
              {{ this.projectInfo.requestOpenDate }}
            </span>
          </template>
        </el-tooltip>
         

        <el-tooltip effect="light" :open-delay="500">
          <el-menu-item index="11">
            <span class="icon">
              <img src="../assets/icon/11.svg" alt="" />
            </span>
            <span class="title" v-if="isShow">
              <span>
                {{ this.projectInfo.useOldFixture }}
              </span>
            </span>
          </el-menu-item>
          <template slot="content">
            <span style="display:flex; align-items: center;">
              {{ this.projectInfo.useOldFixture }}
            </span>
          </template>
        </el-tooltip>
         <!-- Fixture Age -->
         <el-tooltip effect="light" :open-delay="500">
          <el-menu-item index="12">
            <span class="icon">
              <img src="../assets/icon/FixtureAge.svg" alt="" />
            </span>
            <span class="title" v-if="isShow">
              <span>Fixtrue Age: {{this.projectInfo.fixture_Age}} m</span>
            </span>
          </el-menu-item>
          <template slot="content">
            <span style="display:flex; align-items: center;">
              <template>
                  <span>Fixtrue Age: {{this.projectInfo.fixture_Age}} m</span>
              </template>
            </span>
          </template>
        </el-tooltip>

        <el-tooltip effect="light" :open-delay="500">
          <el-menu-item index="12">
            <span class="icon">
              <img src="../assets/icon/12.svg" alt="" />
            </span>
            <span class="title" v-if="isShow">
              <span>
                >150m
                <img
                  class="suffix"
                  v-if="this.projectInfo.color === 2"
                  src="../assets/icon/gantanhao.svg"
                />
                <img class="suffix" v-else src="../assets/icon/check.svg" />
              </span>
            </span>
          </el-menu-item>
          <template slot="content">
            <span style="display:flex; align-items: center;">
              <template v-if="this.projectInfo.tips">
                {{ this.projectInfo.tips }}
              </template>
              <template v-else>
                >150m
                <img
                  class="suffix"
                  style="width: 15px;margin-left: 5px"
                  v-if="this.projectInfo.color === 2"
                  src="../assets/icon/gantanhao.svg"
                />
                <img
                  class="suffix"
                  style="width: 15px;margin-left: 5px"
                  v-else
                  src="../assets/icon/check.svg"
                />
              </template>
            </span>
          </template>
        </el-tooltip>
        <!-- TC值 -->
         <el-tooltip effect="light" :open-delay="500">
          <el-menu-item index="12">
            <span class="icon">
              <img src="../assets/icon/tc.svg" alt="" />
            </span>
            <span class="title" v-if="isShow">
              <span>{{setTC}}</span>
            </span>
          </el-menu-item>
          <template slot="content" v-if="setTC">
            <span style="display:flex; align-items: center;">
              <template>
                 <span>{{setTC}}</span>
              </template>
            </span>
          </template>
        </el-tooltip>
      
      </el-menu>
      <div class="ssBtn" @click="fn">
        <el-icon v-if="isShow" class="el-icon-arrow-left"></el-icon>
        <el-icon v-if="!isShow" class="el-icon-arrow-right"></el-icon>
      </div>
    </div>
    <div class="main">
      <div class="wrapper">
        <div class="btns">
          <div class="left">
            <div>{{ this.projectInfo.projectCode }}</div>
            <span>
              {{ this.projectInfo.groupcustomer }}
              {{ this.projectInfo.streetEN }}
            </span>
          </div>
          <div class="right" v-if="isapprove">
            <el-popover width="450" v-model="visibleA">
              <p style="display: flex; flex-direction: column">
                <b
                  >Comments<b style="color: rgb(169, 169, 169)"
                    >(You can comment here if needed)</b
                  ></b
                >
                <el-input
                  style="
                    margin: 10px 0;
                    word-break: keep-all;
                    word-wrap: break-word;
                  "
                  placeholder="You can comment here if needed"
                  type="textarea"
                  :autosize="{ minRows: 6, maxRows: 6 }"
                  v-model="textareaapprove"
                  @keyup.enter.native="textareaappHanlder"
                  @input="textareaappHanlderRest"
                >
                </el-input>
              </p>
              <div style="text-align: right; margin: 0">
                <el-button
                  type="success"
                  size="mini"
                  :disabled="isDisable"
                  @click="postApproval(1, textareaapprove)"
                  >Submit
                </el-button>
              </div>
              <el-button
                style="margin-right: 30px"
                slot="reference"
                type="success"
                >Approve</el-button
              >
            </el-popover>
            <el-popover width="450" v-model="visibleT">
              <p style="display: flex; flex-direction: column">
                <b>Reject Comments</b>
                <el-input
                  style="
                    margin: 10px 0;
                    word-break: keep-all;
                    word-wrap: break-word;
                  "
                  type="textarea"
                  :autosize="{ minRows: 6, maxRows: 6 }"
                  v-model="textarea"
                  @keyup.enter.native="textareaHanlder"
                  @input="textareaHanlderRest"
                >
                </el-input>
              </p>
              <div style="text-align: right; margin: 0">
                <el-button
                  type="danger"
                  size="mini"
                  :disabled="isDisable"
                  @click="postApproval(2, textarea)"
                  >Submit
                </el-button>
              </div>
              <el-button slot="reference" type="danger" plain>Reject</el-button>
            </el-popover>
          </div>
        </div>
        <transition name="el-zoom-in-top">
          <div v-if="pack">
            <div class="top" v-if="isapprove">
              <div class="process">
                <div class="line">
                  <el-progress
                    type="line"
                    color="#ff9700"
                    :percentage="percentage"
                    :stroke-width="2"
                    :format="format"
                  ></el-progress>
                </div>
                <div class="points">
                  <div class="pointContent">
                    <template v-for="i in process">
                      <div :key="i.order" style="text-align: center">
                        <p
                          :class="[
                            tableDatared && projectInfo.employee == i.employee
                              ? 'rj'
                              : i.approvalResult == '3902'
                              ? 'tg'
                              : i.approvalResult == '3901'
                              ? 'common'
                              : 'common'
                          ]"
                        ></p>
                        <p
                          style="
                            font-weight: 600;
                            position: absolute;
                            top: 45px;
                            left: -35px;
                            width: 120px;
                          "
                        >
                          {{ i.name }}
                        </p>
                        <p
                          v-if="i.approvalResult == '3902'"
                          style="
                            font-weight: 600;
                            color: #75777a;
                            position: absolute;
                            top: 95px;
                            left: -35px;
                            width: 100px;
                          "
                        >
                          {{ i.approveDate }}
                        </p>
                        <div
                          v-if="
                            tableData.length > 0 &&
                              projectInfo.employee == i.employee
                          "
                          style="
                            display: flex;
                            flex-direction: row;
                            position: absolute;
                            top: 95px;
                            left: 5px;
                          "
                        >
                          <el-popover
                            placement="bottom"
                            trigger="click"
                            v-model="visible"
                          >
                            <el-table
                              class="project-table"
                              :data="tableData"
                              max-height="400"
                              style="width: 600px"
                              :show-header="false"
                            >
                              <el-table-column style="border: 2">
                                <template slot-scope="scope">
                                  <div
                                    v-if="scope.row.groupDetail"
                                    style="margin-left: 30px"
                                  >
                                    <p class="fontbold">
                                      {{ scope.row.createDateGroup }}
                                    </p>
                                    <p class="fontbold">
                                      【Rejected by
                                      {{ scope.row.comment_name }}】
                                    </p>
                                    <div
                                      v-for="(item, index) in scope.row
                                        .groupDetail"
                                      :key="index"
                                    >
                                      <p
                                        style="
                                          word-break: keep-all;
                                          word-wrap: break-word;
                                        "
                                      >
                                        &nbsp;&nbsp;●{{ item.comment }}
                                      </p>
                                    </div>
                                    <br />
                                    <p class="fontbold">
                                      【Answered by
                                      {{ scope.row.anwser_name }}】
                                    </p>
                                    <div
                                      v-for="(item, index) in scope.row
                                        .groupDetail"
                                      :key="index"
                                    >
                                      <p
                                        style="
                                          word-break: keep-all;
                                          word-wrap: break-word;
                                        "
                                      >
                                        &nbsp;&nbsp;●{{ item.answer }}
                                      </p>
                                    </div>
                                  </div>
                                  <div
                                    v-if="
                                      scope.row.groupDetail &&
                                        scope.row.groupUpdate
                                    "
                                    style="margin-left: 30px"
                                  >
                                    <br />
                                    <p class="fontbold">
                                      【Updated by {{ scope.row.update_name }}】
                                    </p>
                                    <div
                                      v-for="(item, index) in scope.row
                                        .groupUpdate"
                                      :key="index"
                                    >
                                      <p
                                        style="
                                          word-break: keep-all;
                                          word-wrap: break-word;
                                        "
                                      >
                                        &nbsp;&nbsp;{{ item.comment }}
                                      </p>
                                    </div>
                                  </div>
                                  <div
                                    v-if="
                                      !scope.row.groupDetail &&
                                        scope.row.groupUpdate
                                    "
                                    style="margin-left: 30px"
                                  >
                                    <p class="fontbold">
                                      {{ scope.row.createDateGroup }}
                                    </p>
                                    <p class="fontbold">
                                      【Updated by {{ scope.row.update_name }}】
                                    </p>
                                    <div
                                      v-for="(item, index) in scope.row
                                        .groupUpdate"
                                      :key="index"
                                    >
                                      <p
                                        style="
                                          word-break: keep-all;
                                          word-wrap: break-word;
                                        "
                                      >
                                        &nbsp;&nbsp;{{ item.comment }}
                                      </p>
                                    </div>
                                  </div>
                                  <div
                                    v-if="scope.row.approveDetail"
                                    style="margin-left: 30px"
                                  >
                                    <p
                                      class="fontbold"
                                      style="margin-left: 5px; margin-top: 5px"
                                    >
                                      {{ scope.row.createDateGroup }}
                                    </p>
                                    <p class="fontbold">
                                      【Approved by
                                      {{ scope.row.update_name }}】
                                    </p>
                                    <div
                                      v-for="(item, index) in scope.row
                                        .approveDetail"
                                      :key="index"
                                    >
                                      <p
                                        style="
                                          word-break: keep-all;
                                          word-wrap: break-word;
                                        "
                                      >
                                        &nbsp;&nbsp;●{{ item.comment }}
                                      </p>
                                    </div>
                                  </div>
                                </template>
                              </el-table-column>
                            </el-table>
                            <img
                              src="../assets/icon/info.png"
                              alt=""
                              :style="{marginLeft: '8px', marginTop: i.approveDate ? '20px': 0,width:'20px'}"
                              slot="reference"
                            />
                          </el-popover>
                        </div>
                      </div>
                    </template>
                  </div>
                </div>
              </div>
            </div>
            <div class="top" v-if="!isapprove">
              <div class="process">
                <div class="line">
                  <el-progress
                    type="line"
                    color="#ff9700"
                    :percentage="percentage"
                    :stroke-width="2"
                    :format="format"
                  ></el-progress>
                </div>
                <div class="points">
                  <div class="pointContent">
                    <template v-for="i in process">
                      <div :key="i.order" style="text-align: center">
                        <p
                          :class="[
                            tableDatared && projectInfo.employee == i.employee
                              ? 'rj'
                              : i.approvalResult == '3902'
                              ? 'tg'
                              : i.approvalResult == '3901'
                              ? 'common'
                              : 'common'
                          ]"
                        ></p>
                        <p
                          style="
                            font-weight: 600;
                            position: absolute;
                            top: 45px;
                            left: -35px;
                            width: 120px;
                          "
                        >
                          {{ i.name }}
                        </p>
                        <p
                          v-if="i.approvalResult == '3902'"
                          style="
                            font-weight: 600;
                            color: #75777a;
                            position: absolute;
                            top: 95px;
                            left: -35px;
                            width: 100px;
                          "
                        >
                          {{ i.approveDate }}
                        </p>
                        <div
                          v-if="
                            (tableData.length > 0 &&
                              projectInfo.employee == i.employee) ||
                              (tableData.length > 0 && isadmin && i.order == 1)
                          "
                          style="
                            display: flex;
                            flex-direction: row;
                            position: absolute;
                            top: 95px;
                            left: 5px;
                          "
                        >
                          <el-popover
                            placement="bottom"
                            trigger="click"
                            v-model="visible"
                          >
                            <el-table
                              class="project-table"
                              :data="tableData"
                              max-height="400"
                              style="width: 600px"
                              :show-header="false"
                            >
                              <el-table-column style="border: 2">
                                <template slot-scope="scope">
                                  <div
                                    v-if="scope.row.groupDetail"
                                    style="margin-left: 30px"
                                  >
                                    <p class="fontbold">
                                      {{ scope.row.createDateGroup }}
                                    </p>
                                    <p class="fontbold">
                                      【Rejected by
                                      {{ scope.row.comment_name }}】
                                    </p>
                                    <div
                                      v-for="(item, index) in scope.row
                                        .groupDetail"
                                      :key="index"
                                    >
                                      <p
                                        style="
                                          word-break: keep-all;
                                          word-wrap: break-word;
                                        "
                                      >
                                        &nbsp;&nbsp;●{{ item.comment }}
                                      </p>
                                    </div>
                                    <br />
                                    <p class="fontbold">
                                      【Answered by
                                      {{ scope.row.anwser_name }}】
                                    </p>
                                    <div
                                      v-for="(item, index) in scope.row
                                        .groupDetail"
                                      :key="index"
                                    >
                                      <p
                                        style="
                                          word-break: keep-all;
                                          word-wrap: break-word;
                                        "
                                      >
                                        &nbsp;&nbsp;●{{ item.answer }}
                                      </p>
                                    </div>
                                  </div>
                                  <div
                                    v-if="
                                      scope.row.groupDetail &&
                                        scope.row.groupUpdate
                                    "
                                    style="margin-left: 30px"
                                  >
                                    <br />
                                    <p class="fontbold">
                                      【Updated by {{ scope.row.update_name }}】
                                    </p>
                                    <div
                                      v-for="(item, index) in scope.row
                                        .groupUpdate"
                                      :key="index"
                                    >
                                      <p
                                        style="
                                          word-break: keep-all;
                                          word-wrap: break-word;
                                        "
                                      >
                                        &nbsp;&nbsp;{{ item.comment }}
                                      </p>
                                    </div>
                                  </div>
                                  <div
                                    v-if="
                                      !scope.row.groupDetail &&
                                        scope.row.groupUpdate
                                    "
                                    style="margin-left: 30px"
                                  >
                                    <p class="fontbold">
                                      {{ scope.row.createDateGroup }}
                                    </p>
                                    <p class="fontbold">
                                      【Updated by {{ scope.row.update_name }}】
                                    </p>
                                    <div
                                      v-for="(item, index) in scope.row
                                        .groupUpdate"
                                      :key="index"
                                    >
                                      <p
                                        style="
                                          word-break: keep-all;
                                          word-wrap: break-word;
                                        "
                                      >
                                        &nbsp;&nbsp;{{ item.comment }}
                                      </p>
                                    </div>
                                  </div>
                                  <div
                                    v-if="scope.row.approveDetail"
                                    style="margin-left: 30px"
                                  >
                                    <p
                                      class="fontbold"
                                      style="margin-left: 5px; margin-top: 5px"
                                    >
                                      {{ scope.row.createDateGroup }}
                                    </p>
                                    <p class="fontbold">
                                      【Approved by
                                      {{ scope.row.update_name }}】
                                    </p>
                                    <div
                                      v-for="(item, index) in scope.row
                                        .approveDetail"
                                      :key="index"
                                    >
                                      <p
                                        style="
                                          word-break: keep-all;
                                          word-wrap: break-word;
                                        "
                                      >
                                        &nbsp;&nbsp;●{{ item.comment }}
                                      </p>
                                    </div>
                                  </div>
                                </template>
                              </el-table-column>
                            </el-table>
                            <img
                              src="../assets/icon/info.png"
                              alt=""
                              :style="{marginLeft: '8px', marginTop: i.approveDate ? '20px': 0,width:'20px'}"
                              slot="reference"
                            />
                          </el-popover>
                        </div>
                      </div>
                    </template>
                  </div>
                </div>
              </div>
            </div>
            <div class="center" v-if="isapprove">
              <div class="title">
                <div style="width: 400px">
                  <span v-if="!!centerData && centerData.length > 0">{{
                    this.projectInfo.posProtfolio
                  }}</span>
                </div>
                <div style="width: 900px">
                  <span v-if="!!centerRightN">{{
                    this.projectInfo.posytdProgress
                  }}</span>
                </div>
              </div>
              <div class="txPic">
                <div class="detail">
                  <template v-for="(a, i) in centerText">
                    <div
                      v-if="a.poscount > 0"
                      :key="i"
                      style="
                        height: 40px;
                        width: 100%;
                        margin-bottom: 2px;
                        display: flex;
                      "
                    >
                      <div style="flex: 1"></div>
                        <!-- // 这里 -->
                      <div
                        :style="{
                          width: a.posPercent === '100%' ?  '260px':a.width,
                          backgroundColor: a.bg
                        }"
                        style="line-height: 40px"
                      >
                        <span
                          :class="{
                            fontBold: a.fontweight
                          }"
                          >{{ a.posPercent }}; {{ a.poscount }}</span
                        >
                      </div>
                      <div style="flex: 1; padding-top: 32px">
                        <div
                          :style="{
                            backgroundColor: a.bgl,
                            height: a.height
                          }"
                          style="width: 100%"
                        ></div>
                      </div>
                      <div
                        style="width: 100px; display: flex; position: relative"
                      >
                        <div style="flex: 1; padding-top: 32px">
                          <div
                            :style="{
                              backgroundColor: a.bgl,
                              height: a.height
                            }"
                            style="width: 100%"
                          ></div>
                        </div>
                        <div
                          style="
                            position: absolute;
                            font-size: 12px;
                            width: 100%;
                            top: 0;
                            left: 0;
                            height: 32px;
                            display: flex;
                            align-items: flex-end;
                            justify-content: space-between;
                          "
                        >
                          <div
                            :class="{ fontBoldLine: a.fontweight }"
                            style="flex: 1; text-align: end"
                          >
                            {{ a.name }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </template>
                </div>
              </div>
              <div class="linePic">
                <template v-for="(v, k) in centerRightN">
                  <div class="item" :style="{ zIndex: v.order }" :key="v.order">
                    <div
                      :style="{ width: v.width, backgroundColor: v.bg }"
                      style="
                        height: 44px;
                        color: #bcc3cd;
                        font-size: 12px;
                        border-radius: 22px;
                        line-height: 44px;
                        text-align: right;
                        padding-right: 40px;
                        border: 2px solid #b6bdc8;
                      "
                    >
                      <div :class="v.cName">
                        <span
                          >{{ k.charAt(0).toUpperCase() + k.slice(1) }}:{{
                            v.bfb
                          }}; {{ v.showContent }}</span
                        >
                        <img :src="v.img" alt="" />
                      </div>
                    </div>
                  </div>
                </template>
              </div>
            </div>
            <div style="width: 100%; text-align: center">
              <span
                style="
                  border-radius: 0 0 38px 38px;
                  margin: 0 auto;
                  display: block;
                  width: 76px;
                  height: 12px;
                  font-size: 12px;
                  line-height: 12px;
                  cursor: pointer;
                  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.5);
                "
                @click="pack = !pack"
              >
                <el-icon class="el-icon-arrow-down" v-if="!pack"></el-icon>
                <el-icon class="el-icon-arrow-up" v-if="pack"></el-icon>
              </span>
            </div>
          </div>
        </transition>
        <div class="bottom">
          <div class="img" @click="pack = !pack">
            <pdf ref="pdf" v-for="i in numPages" :key="i" :src="src" :page="i">
            </pdf>
          </div>
        </div>
        <div class="dialog" v-if="isSp">
          <div
            class="txt"
            style="width: 360px; text-align: left; margin: 0 auto 10px"
          >
            {{ alertmsg }}<br /><br />It will jump to the next project code in
            {{ timeNum }}
            seconds...
          </div>
          <div class="time" style="font-size: 80px">
            {{ timeNum }}
          </div>
          <div class="btns">
            <el-button size="small" @click="intervalButtom(2)">
              Next Project <i class="el-icon-right el-icon--right"></i
            ></el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import pdf from "vue-pdf";
import onePic from "../assets/icon/one-line.png";
import twoPic from "../assets/icon/two-line.png";
import threePic from "../assets/icon/three-line.png";
import fourPic from "../assets/icon/four-line.png";
import twoImg from "../assets/icon/one.png";
import threeImg from "../assets/icon/three.png";
import fourImg from "../assets/icon/two.png";
import fiveImg from "../assets/icon/four.png";
import sixImg from "../assets/icon/money.png";
import sevenImg from "../assets/icon/floor.png";
import eightImg from "../assets/icon/five.png";
import nineImg from "../assets/icon/six.png";
import tenImg from "../assets/icon/seven.png";
import elevenImg from "../assets/icon/nine.png";
import fixtureImg from "../assets/icon/fixture.png";
import {decryption} from '@/utils/secret.js'

export default {
  components: {
    pdf
  },
  data() {
    return {
      pack: true,
      timer: null,
      isSp: false,
      timeNum: 3,
      isShow: true,
      isDisable: false,
      baseurl: "/static/Attachment/",
      url: "",
      src: undefined,
      numPages: undefined,
      projectInfo: {
        groupCustomer_Name: ""
      },
      projectInfoStreetEN: null,
      space: null,
      mpsa: null,
      formats: null,
      visible: false,
      visibleA: false,
      visibleT: false,
      process: null,
      centerData: null,
      centerRight: null,
      textareaapprove: "●",
      textarea: "●",
      tableData: [],
      tableDatared: false,
      page: "",
      isapprove: false,
      middlePageNum: null,
      alertmsg: null,
      isadmin: false,
      iconList: [
        twoImg,
        threeImg,
        fourImg,
        fiveImg,
        sixImg,
        sevenImg,
        eightImg,
        nineImg,
        tenImg,
        elevenImg,
        fixtureImg
      ]
    };
  },
  computed: {
    setTC() {
      if(this.projectInfo.action=== 'New') {
        if(this.projectInfo.tC_Now === 'Y') {
          return 'TC: → Y';
        } else {
          return ''
        }
      } else {
        return `TC: ${this.projectInfo.tC_UP} → ${this.projectInfo.tC_Now}`;
      }
    },
    allPoints() {
      if (!!this.process) {
        return this.process.length;
      }
    },
    finishPoints() {
      let tmp = 0;
      if (this.process) {
        this.process.forEach(a => {
          if (a.approvalResult == "3902") {
            tmp++;
          }
        });
      }
      return tmp;
    },
    percentage() {
      let tmp = 0;
      if (this.allPoints > 0) {
        tmp = (this.finishPoints / (this.allPoints - 1)) * 100;
      }
      return tmp;
    },
    centerText() {
      let wList = [60, 90, 140, 180, 260];
      let result = JSON.parse(JSON.stringify(this.centerData));
      if (!!this.centerData) {
        let tmp = this.centerData
          .sort((a, b) => {
            return a.poscount - b.poscount;
          })
          .map((c, i) => {
            let obj = {
              name: c.name,
              poscount: c.poscount,
              width: wList[i] + "px"
            };
            return obj;
          });
        let posTotal = 0;
        result.forEach(item => {
          posTotal += item.poscount;
        });
        result.forEach((item, i) => {
          let oItem = tmp.find(d => {
            return d.name === item.name;
          });
          item.posPercent = ((item.poscount / posTotal) * 100).toFixed(0) + "%";
          item.width = oItem.width;
          item.height = "1px";
          item.fontweight = false;
          item.bg = `rgba(70, 89, 117,${0.15 * (i + 1)})`;
          item.bgl = `rgba(70, 89, 117,${0.15 * (i + 1)})`;
          if (item.name == this.projectInfo.formtGroup) {
            item.height = "3px";
            item.bgl = `rgba(255, 165, 0,${0.15 * (i + 1)})`;
            item.fontweight = true;
          }
        });
        return result;
      }
    },
    centerRightN() {
      if (this.centerRight) {
        let tmp = JSON.parse(JSON.stringify(this.centerRight));
        if (tmp.opened) {
          let arr1 = [onePic, fourPic, threePic, twoPic];
          let arr2 = ["#465975", "#6b7b91", "#909bac", "transparent"];
          let arr3 = ["onePic", "fourPic", "threePic", "twoPic"];
          let discountPpipeline = tmp.pipeline.value * 0.75;
          let DiscountApproval = tmp.approval.value * 0.5;


          let allVall = tmp.opened.value + discountPpipeline + DiscountApproval;
          let targetVal = tmp.target.value;
          if (tmp.target.value == 0) {
            targetVal = allVall * 1.2;
          }
          let num = 0;
          for (let k in tmp) {
            tmp[k].img = arr1[num];
            tmp[k].bg = arr2[num];
            tmp[k].cName = arr3[num];
            tmp[k].showContent = tmp[k].value;
            num++;
          }
          tmp.target.bfb = 100 + "%";
          if (tmp.target.value == 0) {
            tmp.target.showContent = "TGT is WIP";
          }
          if (allVall <= targetVal) {
            tmp.opened.width = (tmp.opened.value / targetVal) * 900 + "px";
            tmp.opened.bfb =
              (isNaN(tmp.opened.value / targetVal) ?0:(tmp.opened.value / targetVal) * 100).toFixed(0) + "%";
            tmp.opened.order = 3;
            tmp.pipeline.width =
              ((tmp.opened.value + discountPpipeline) / targetVal) * 900 + "px";
            tmp.pipeline.bfb =
              (
                isNaN((tmp.opened.value + discountPpipeline) / targetVal)?0:((tmp.opened.value + discountPpipeline) / targetVal) *
                100
              ).toFixed(0) + "%";
            tmp.pipeline.order = 2;
            tmp.approval.width = (allVall / targetVal) * 900 + "px";
            tmp.approval.bfb = (isNaN(allVall / targetVal)?0: (allVall / targetVal)* 100).toFixed(0) + "%";
            tmp.approval.order = 1;
            tmp.target.width = 900 + "px";
            tmp.target.order = 10;
          } else {
            tmp.opened.width = (tmp.opened.value / allVall) * 900 + "px";
            tmp.opened.bfb =
              ((tmp.opened.value / targetVal) * 100).toFixed(0) + "%";
            tmp.opened.order = 3;
            tmp.pipeline.width =
              ((tmp.opened.value + discountPpipeline) / allVall) * 900 + "px";
            tmp.pipeline.bfb =
              (
                ((tmp.opened.value + discountPpipeline) / targetVal) *
                100
              ).toFixed(0) + "%";
            tmp.pipeline.order = 2;
            tmp.approval.width = 900 + "px";
            tmp.approval.bfb = ((allVall / targetVal) * 100).toFixed(0) + "%";
            tmp.approval.order = 1;
            tmp.target.width = (targetVal / allVall) * 900 + "px";
            tmp.target.order = 10;
          }
          return tmp;
        }
      }
    }
  },
  methods: {
    isEmpty(obj) {
      if (typeof obj == "undefined" || obj == null || obj == "") {
        return true;
      } else {
        return false;
      }
    },
    textareaappHanlder() {
      this.textareaapprove += "●";
    },
    textareaHanlder() {
      this.textarea += "●";
    },
    textareaHanlderRest() {
      if (this.textarea.length == 0) {
        this.textarea = "●";
      }
    },
    textareaappHanlderRest() {
      if (this.textareaapprove.length == 0) {
        this.textareaapprove = "●";
      }
    },
    fn() {
      this.isShow = !isShow;
    },
    //返回上级页面
    back() {
      // this.$router.go(-1);
      if(this.isapprove) {
         this.$router.replace('/List')
      } else {
         this.$router.replace('/EndList')
      }

    },
    format() {
      return "";
    },
    //#region 计算pdf页面总数
    getNumPages(pdfUrl) {
      let loadingTask = pdf.createLoadingTask(`${pdfUrl}?verson=${Date.now()}`);
      this.src = loadingTask;
      loadingTask.promise
        .then(pdf => {
          this.numPages = pdf.numPages;
        })
        .catch(err => {
          console.error("pdf 加载失败", err);
        });
    },
    // 获取项目信息
    bindData(projectID) {
      this.isDisable = false;
      var approval = 0;
      if (!this.isapprove) {
        approval = 1;
      }

      this.$api
        .get("/Login/IsAdmin/", {}, res => {})
        .then(res => {
          this.isadmin = res.data;
        });

      this.$api
        .get("/Project/GetProjectInfo", {
          projectID: projectID,
          approval: approval
        })
        .then(res => {
          if (res.data.status == true) {
            this.projectInfo = res.data.content;
            if (
              !!this.projectInfo.streetEN &&
              this.projectInfo.streetEN.length > 24
            ) {
              this.projectInfoStreetEN =
                this.projectInfo.streetEN.substring(0, 21) + "...";
            } else {
              this.projectInfoStreetEN = this.projectInfo.streetEN;
            }
            if (this.projectInfo.action != "New") {
              this.space =
                this.projectInfo.space_Up +
                "㎡" +
                " → " +
                this.projectInfo.space_Now +
                "㎡";
              this.formats =
                this.projectInfo.format_Up +
                " → " +
                this.projectInfo.format_Now;
              this.mpsa =
                this.projectInfo.mpsA_Up +
                "K → " +
                this.projectInfo.mpsA_Now +
                "K";
            } else {
              this.space = this.projectInfo.space_Now + "㎡";
              this.formats = this.projectInfo.format_Now;
              this.mpsa = this.projectInfo.mpsA_Now + "K";
            }
          } else {
            if (res.data.message == "Login Error") {
              this.$router.push({ path: "/" });
            } else if (res.data.message == "不存在的项目") {
              this.$router.go(-1);
            } else {
              console.log("bind");
              this.$message({
                type: "error",
                message: res.data.message
              });
              return false;
            }
          }
        });
    },
    // 获取审批人信息
    bindApprovalData(projectID) {
      this.$api
        .get("/Project/GetApprovalInfos", {
          projectID: projectID
        })
        .then(res1 => {
          if (res1.data.status == true) {
            this.process = res1.data.content;
          } else {
            if (res1.data.message == "Login Error") {
              this.$router.push({ path: "/" });
            } else {
              console.log("bindapproldata");
              this.$message({
                type: "error",
                message: res1.data.message
              });
              return false;
            }
          }
        });
    },
    // 获取审批历史信息
    bindApprovalHistoryData(projectID) {
      this.$api
        .get("/Project/GetApprovalHistoryInfos", {
          projectID: projectID
        })
        .then(res5 => {
          if (res5.data.status == true) {
            this.tableData = res5.data.content != null ? res5.data.content : [];
            if (this.tableData.length != 0) {
              for (var i = 0; i < this.tableData.length; i++) {
                if (this.tableData[i].groupDetail != null) {
                  this.tableDatared = true;
                }
              }
            }
          } else {
            if (res5.data.message == "Login Error") {
              this.$router.push({ path: "/" });
            } else {
              console.log("bindApprovalHistoryData");
              this.$message({
                type: "error",
                message: res5.data.message
              });
              return false;
            }
          }
        });
    },
    // 获取金字塔信息
    bindPyramidData(projectID) {
      this.$api
        .get("/List/GetPyramidData", {
          projectID: projectID
        })
        .then(res4 => {
          if (res4.data.status == true) {
            this.centerData = res4.data.content;
          } else {
            if (res4.data.message == "Login Error") {
              this.$router.push({ path: "/" });
            } else {
              console.log("bindPyramidData");
              this.$message({
                type: "error",
                message: res4.data.message
              });
              return false;
            }
          }
        });
    },
    // 获取开店进度信息
    bindApprovalProcess(projectID) {
      this.$api
        .get("/Project/GetApprovalProcess", {
          projectID: projectID
        })
        .then(res6 => {
          if (res6.data.status == true) {
            this.centerRight = res6.data.content;
          } else {
            if (res6.data.message == "Login Error") {
              this.$router.push({ path: "/" });
            } else {

              this.$message({
                type: "error",
                message: res6.data.message
              });
              return false;
            }
          }
        });
    },
    // 获取附件名
    bindAttachment(projectID) {
      this.$api
        .get("/Project/GetApprovalAttachment", {
          projectID: projectID
        })
        .then(res3 => {
          if (res3.data.status == true) {
            this.url = this.baseurl + res3.data.content + ".pdf";
          } else {
            if (res3.data.message == "Login Error") {
              this.$router.push({ path: "/" });
            } else {

              this.$message({
                type: "error",
                message: res3.data.message
              });
              return false;
            }
          }
        });
    },
    // 调用审批接口
    postApproval(operate, comment) {
      this.isDisable = true; //点击后禁用该按钮
      if (operate == 2) {
        if (comment == "●") {
          this.$message({
            type: "error",
            message: "Reject commonts is required."
          });
          return;
        }
        this.textarea = "●";
        comment = comment
          .split("\n")
          .join("<br>")
          .replace(/●/g, "");
      } else if (operate == 1) {
        if (comment == "●") {
          comment = "";
        } else {
          comment = comment
            .split("\n")
            .join("<br>")
            .replace(/●/g, "");
        }
        this.textareaapprove = "●";
      }

      let projectID = this.page;

      this.$api
        .post("Project/BatchApproveProject", {
          projectID: [projectID],
          operate: operate,
          comment: comment
        })
        .then(res2 => {
          if (res2.data.status == true) {
            this.middlePageNum = res2.data.content.projectID;
            let content = res2.data.content;
            this.intervalAlert(operate, content);
          } else {
            if (res2.data.message == "Login Error") {
              this.$router.push({ path: "/" });
            } else {

              this.$message({
                type: "error",
                message: res2.data.message
              });
              return false;
            }
          }
          if (operate == 2) {
            this.visibleT = false;
          } else if (operate == 1) {
            this.visibleA = false;
          }
        });
    },
    //倒计时提示
    intervalAlert(operate, content) {
      this.isSp = true;
      this.timeNum = 3;
      this.alertmsg = "Successfully Rejected!";
      if (operate == 1) {
        this.alertmsg = "Successfully Approved!";
      }
      if (!this.timer) {
        this.timer = setInterval(() => {
          if (this.timeNum > 1 && this.timeNum <= 3) {
            //限制倒计时区间
            this.timeNum--;
          } else {
            clearInterval(this.timer); //删除定时器
            this.timer = null;
            this.isSp = false;
            //跳转的页面写在此处
            if (content.projectID == 0) {
              this.$router.push({ path: "/ApprovalIndex/" });
            } else {
              if (content.type == "Closure") {
                this.$router.push({
                  name: "Closure",
                  params: {
                    ID: content.projectID,
                    isapprove: this.$route.params.isapprove
                  }
                });
              } else {
                this.page = content.projectID;
              }
            }
          }
        }, 1000);
      } else {
        this.timer.clearTimer();
      }
    },
    //倒计时内按钮参数1表示返回，2表示下一个
    intervalButtom(choice) {
      clearInterval(this.timer); //删除定时器
      this.timer = null;
      this.isSp = false;
      if (choice == 1) {
        this.$router.go(-1);
      } else {
        this.page = this.middlePageNum;
      }
    }
  },
  watch: {
    page(val) {
      this.bindData(val);
      this.bindApprovalData(val);
      this.bindApprovalHistoryData(val);
      this.bindPyramidData(val);
      this.bindAttachment(val);
      this.bindApprovalProcess(val);
    },
    url(val) {
      this.getNumPages(val);
    }
  },
  mounted() {
    this.$nextTick(() => {
      // this.page = this.$route.params.ID;
      // this.isapprove = this.$route.params.isapprove;

      this.page = decryption(this.$route.query.ID);
      this.isapprove = JSON.parse(decryption(this.$route.query.isapprove));
    });
  }
};
</script>

<style scoped>
#home {
  height: 100vh;
  width: 100%;
  background: #fbfbfb;
  display: flex;
}

#home .header {
  margin-bottom: 10px;
  padding: 0 24px;
  display: flex;
}

#home .nav-menu {
  width: auto;
  padding-top: 40px;
  background: #27333d;
  position: relative;
}
#home .nav-menu .ssBtn {
  border-radius: 0 38px 38px 0;
  width: 12px;
  height: 76px;
  text-align: center;
  font-size: 12px;
  line-height: 76px;
  position: absolute;
  right: -12px;
  top: 50%;
  cursor: pointer;
  z-index: 10;
  transform: translateY(-38px);
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.5);
}
#home .main {
  flex: 1;
}

#home .el-menu {
  border-right: none;
}

#home .el-menu-item {
  padding: 0 !important;
  cursor: default;
}

#home .el-menu-item.is-active {
  color: #eeeeef;
}

#home .el-menu-vertical-demo .icon {
  width: 80px;
  img {
    width: 30px;
    object-fit: contain;
  }
}

#home .el-menu-vertical-demo .title {
  width: 207px;
  text-align: left;
  padding: 0 10px;
  height: 58px;
  line-height: 58px;
  border-bottom: 1px solid #424a52;
  border-top: 1px solid #424a52;
  text-indent: 1em;

  span {
    display: flex;
    align-items: center;
  }
  .suffix {
    width: 20px;
    margin-left: 10px;
  }
}

#home .el-menu-vertical-demo .titleFirst {
  border: none;
}

#home .el-menu-item {
  padding: 0;
  display: flex;
}
p {
  margin: 0;
}

div {
  box-sizing: border-box;
}

.wrapper {
  width: 100%;
  height: 100%;
  display: flex;
  padding: 0 25px;
  box-sizing: border-box;
  flex-direction: column;
}

.wrapper .dialog {
  width: 500px;
  height: 300px;
  background: rgba(0, 0, 0, 0.5);
  border-radius: 10px;
  z-index: 999;
  position: absolute;
  color: #fff;
  top: 50%;
  right: 50%;
  transform: translate(50%, -50%);
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.wrapper .dialog .btns {
  display: flex;
  justify-content: space-around;
}

.wrapper .top {
  height: 160px;
  border: 1px solid #979797;
  display: flex;
  box-sizing: border-box;
  padding: 15px 0 15px 0;
  justify-content: space-between;
}

.wrapper .top .process {
  height: 100%;
  flex: 1;
  position: relative;
}

.wrapper .top .process .line {
  width: 91%;
  height: 100%;
  box-sizing: border-box;
  padding-top: 7px;
  position: absolute;
  top: 0;
  left: 5%;
  z-index: 1;
  display: flex;
}
.wrapper .top .process .line ::v-deep .el-progress-bar {
  padding: 0 15px !important;
  margin: 0 !important;
}
.wrapper .el-progress.el-progress--line {
  width: 100%;
}

.wrapper .top .process .points {
  width: 91%;
  height: 100%;
  background: transparent;
  position: absolute;
  top: 0;
  left: 5%;
  z-index: 2;
  display: flex;
  flex-direction: column;
}

.wrapper .top .process .points .pointContent {
  flex: 1;
  display: flex;
  justify-content: space-between;
}

.wrapper .top .process .points .pointContent div {
  display: flex;
  flex-direction: column;
  position: relative;
}

.wrapper .top .process .points .pointContent .txt {
  font-weight: 600;
  position: absolute;
  top: 40px;
  left: -15px;
}

.wrapper .tg {
  width: 16px;
  height: 16px;
  background: #90b407;
  border: 7px solid #d2ec9e;
  border-radius: 15px;
  position: relative;
}

.wrapper .rj {
  width: 16px;
  height: 16px;
  background: #ff4b4b;
  border: 7px solid #fcbfbf;
  border-radius: 15px;
  position: relative;
}

.wrapper .common {
  width: 16px;
  height: 16px;
  border: 7px solid #dddddd;
  border-radius: 15px;
  position: relative;
}

.wrapper .btns {
  margin-top: 15px;
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  overflow: hidden;
}
.wrapper .btns .left {
  font-size: 28px;
  padding-top: 15px;
  float: left;
  text-align: left;
}
.wrapper .btns .right {
  float: right;
}
.wrapper .btns .right button {
  height: 50px;
  width: 130px;
}
.fontBold {
  font-weight: bold;
}
.fontBoldLine {
  font-weight: bold;
  color: orange;
}

.wrapper .center {
  height: 300px;
  border: 1px solid #979797;
  margin-top: 15px;
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.wrapper .center .txPic {
  width: 400px;
  height: 100%;
  margin-left: 30px;
  display: flex;
  align-items: center;
  position: relative;
}

.wrapper .center .txPic .detail {
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  right: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.wrapper .center .linePic {
  width: 900px;
  height: 100%;
  display: flex;
  margin-right: 30px;
  align-items: center;
  position: relative;
}

.wrapper .center .linePic .item {
  display: flex;
  /* display: -webkit-box; */
  flex-direction: column;
  justify-content: center;
  align-items: flex-end;
  position: absolute;
  left: 0;
}

.wrapper .center .title {
  position: absolute;
  top: 10px;
  left: 20px;
  width: 95%;
  font-size: 22px;
  z-index: 4;
  line-height: 22px;
  font-weight: 600;
  color: #080808;
  display: flex;
  text-align: left;
  justify-content: space-between;
}

.wrapper .center .linePic .item img {
  transform: scaleY(0.6);
}

.onePic {
  position: absolute;
  top: -40px;
  right: 20px;
  color: #2c3e50;
}
.onePic span {
  position: absolute;
  left: -88px;
  top: -10px;
}
.threePic {
  position: absolute;
  top: -70px;
  right: 20px;
  color: #2c3e50;
}
.threePic span {
  position: absolute;
  left: -90px;
  top: 0;
}
.twoPic {
  position: absolute;
  bottom: -88px;
  right: 20px;
  color: #2c3e50;
}
.twoPic span {
  position: absolute;
  left: -86px;
  bottom: 15px;
}
.fourPic {
  position: absolute;
  bottom: -58px;
  right: 20px;
  color: #2c3e50;
}
.fourPic span {
  position: absolute;
  left: -90px;
  bottom: 10px;
}

.wrapper .bottom {
  flex: 1;
  background: #fff;
  margin-top: 15px;
  overflow: hidden;
  filter: progid:DXImageTransform.Microsoft.Shadow(color=#909090, direction=120, strength=4);
  -moz-box-shadow: 2px 2px 10px #909090;
  -webkit-box-shadow: 2px 2px 10px #909090;
  box-shadow: 2px 2px 10px #909090;
}

.wrapper .bottom .img {
  width: 100%;
  height: 100%;
  overflow-y: auto;
}

.fontbold {
  font-weight: 600;
}
</style>
<style>
.project-table tr td,
.project-table th.is-leaf {
  border-bottom: 1px solid rgb(129 143 165/60%) !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Project.vue